import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, filter, map, of, tap } from 'rxjs';
import { environment } from '@environments/environment';
import { START_PAGE } from '@shared/helpers/redirect.service';
import { SettingsState, SiteName } from '@shared/states/settings.state';

export const TestCanActivateGuard: CanActivateFn = () => {
  return canOpenTestPage();
};

function canOpenTestPage(): Observable<boolean> {
  if (environment.isDevSite || !environment.enabledProdMode) {
    return of(true);
  } else {
    return inject(SettingsState).siteName$.pipe(
      filter((siteName) => !!siteName),
      map((siteName) => siteName === SiteName.Preprod),
      tap((canOpen) => {
        if (!canOpen) {
          inject(Router).navigate([START_PAGE]);
        }
      }),
    );
  }
}
